import { InspectionDetails } from '@/features/inspections/components/inspection-details';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const inspectionSearchSchema = z.object({
  tab: z.enum(['overview', 'inspection', 'interactions']).optional(),
});

export const Route = createFileRoute(
  '/_app/policies/$policyId/inspections/$inspectionId/'
)({
  component: InspectionRoute,
  validateSearch: inspectionSearchSchema,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions([
      'policies.inspections.read',
    ]);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function InspectionRoute() {
  const { policyId, inspectionId } = Route.useParams();
  const { tab } = Route.useSearch();

  return (
    <InspectionDetails
      proposalId={policyId}
      inspectionId={inspectionId}
      initialTab={tab}
    />
  );
}
